import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-ads-checklist',
  templateUrl: './help-google-ads-checklist.component.html'
})
export class HelpGoogleAdsChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
